import React from 'react';
import { getNumbersWithDecimalPlaces } from '../../../utilities/money';
import { resolveAddress } from '../../../services/contactAndContract';
import { CHAIN_EXPLORER } from '../../../constants/chains';
import { getDateTimeFromTimestamp } from '../../../utilities/datetime';
import WalletAddressEllipsis from '../../../components/shared/WalletAddressEllipsis';
import ReceivedDetails from './ReceivedDetails';
import SentDetails from './SentDetails';
import TokenDetails from './TokenDetails';

const transactionDetails = ({ data }) => {
  console.log(data.sends);
  let etherscanAdd = 'https://etherscan.io/address';
  let accountAdd = 'https://fund-manager.vercel.app/defi';

  let explorer = CHAIN_EXPLORER[data?.chain?.id]
    ? `${CHAIN_EXPLORER[data?.chain?.id]}/tx/${data.tx_hash}`
    : `https://www.blockchain.com/explorer/search?search=${data.tx_hash}`;

  return (
    <div className="custom-sdls-left-top-margin">
      <section className="slds-p-around_large">
        <div className="slds-grid slds-grid_pull-padded slds-grid_vertical-align-center slds-m-bottom_large">
          <div className="transaction_detail_half_details">
            <p>Account</p>
            <p style={{ color: '#006DCC', fontWeight: '700' }}>
              <a
                target="_blank"
                href={`${accountAdd}/${data?.account}/overview`}
                rel="noreferrer"
                title={data?.account}
              >
                {resolveAddress(data?.account).name}
              </a>
            </p>
          </div>
          <div className="slds-col_padded" style={{ maxWidth: '542px' }}>
            <p>Transaction Hash</p>
            <a
              style={{
                color: '#006DCC',
                fontWeight: '700',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              className="slds-truncate"
              target="_blank"
              href={explorer}
              rel="noreferrer"
              title={data.tx_hash}
            >
              {resolveAddress(data.tx_hash).name ? (
                resolveAddress(data.tx_hash).name
              ) : (
                <WalletAddressEllipsis text={data?.tx_hash} maxTextCount={20} />
              )}
            </a>
          </div>
        </div>
        {data.receives && data.receives.length > 0 && (
          <ReceivedDetails data={data.receives} linkTo={`${explorer}`} />
        )}
        {data.sends && data.sends.length > 0 && (
          <SentDetails data={data.sends} linkTo={`${explorer}`} />
        )}
        <TokenDetails data={data} />
      </section>
    </div>
  );
};

export default transactionDetails;
